module.exports = __webpack_public_path__ + "static/media/2024 FC2_OTCHS_Catalog_ ALL plans _001_002_003_English.39148440.pdf";